module.exports = __webpack_public_path__ + "fontmb31.93e0c767.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fontmb31.png
// module id = Lbjb
// module chunks = 0